import React from "react";

export default function CalendarIcon() {
  return (
    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.125 9.6875C15.125 9.3078 15.4328 9 15.8125 9H17.1875C17.5672 9 17.875 9.3078 17.875 9.6875V11.0625C17.875 11.4422 17.5672 11.75 17.1875 11.75H15.8125C15.4328 11.75 15.125 11.4422 15.125 11.0625V9.6875Z"
        fill="currentColor" />
      <path
        d="M11 9.6875C11 9.3078 11.3078 9 11.6875 9H13.0625C13.4422 9 13.75 9.3078 13.75 9.6875V11.0625C13.75 11.4422 13.4422 11.75 13.0625 11.75H11.6875C11.3078 11.75 11 11.4422 11 11.0625V9.6875Z"
        fill="currentColor" />
      <path
        d="M4.125 13.8125C4.125 13.4328 4.4328 13.125 4.8125 13.125H6.1875C6.5672 13.125 6.875 13.4328 6.875 13.8125V15.1875C6.875 15.5672 6.5672 15.875 6.1875 15.875H4.8125C4.4328 15.875 4.125 15.5672 4.125 15.1875V13.8125Z"
        fill="currentColor" />
      <path
        d="M8.25 13.8125C8.25 13.4328 8.5578 13.125 8.9375 13.125H10.3125C10.6922 13.125 11 13.4328 11 13.8125V15.1875C11 15.5672 10.6922 15.875 10.3125 15.875H8.9375C8.5578 15.875 8.25 15.5672 8.25 15.1875V13.8125Z"
        fill="currentColor" />
      <path
        d="M4.8125 0.75C5.1922 0.75 5.5 1.0578 5.5 1.4375V2.125H16.5V1.4375C16.5 1.0578 16.8078 0.75 17.1875 0.75C17.5672 0.75 17.875 1.0578 17.875 1.4375V2.125H19.25C20.7688 2.125 22 3.35622 22 4.875V20C22 21.5188 20.7688 22.75 19.25 22.75H2.75C1.23122 22.75 0 21.5188 0 20V4.875C0 3.35622 1.23122 2.125 2.75 2.125H4.125V1.4375C4.125 1.0578 4.4328 0.75 4.8125 0.75ZM1.375 6.25V20C1.375 20.7594 1.99061 21.375 2.75 21.375H19.25C20.0094 21.375 20.625 20.7594 20.625 20V6.25H1.375Z"
        fill="currentColor" />
    </svg>

  );
}


